import { IconBrands } from 'components/Shared/Icon/themes/BGH-RD3/iconBrands';
import cn from 'classnames';
import styles from './styles.scss';
import { NotifyLink } from 'components/Shared/NotifyLink';
import { useCallback } from 'react';
import connect from 'components/Shared/connect';
import { selectOurBrands } from 'components/MainMenu/selectors';
import { selectBlackFridayStatus } from 'components/Header/themes/BGH/selector';
import { useDispatch, useSelector } from 'react-redux';
import { GtmHeaderNavClick } from 'store/googleTagManager/actions';

interface OwnProps {
  outside?: boolean;
}

interface MergedProps extends OwnProps {
  ourBrands: {
    title: string;
    url: string;
    ticket: string;
  };
}

export const OurBrands = connect<MergedProps, OwnProps>(state => ({
  ourBrands: selectOurBrands(state)
}))(function Brands({ ourBrands: { title, url, ticket }, outside }: MergedProps) {
  const reduxDispatch = useDispatch();
  const [, last] = useCallback(() => {
    const index = title.indexOf(' ') + 1;
    return [title.substr(0, index), title.substr(index)];
  }, [title])();

  const handleOnClick = () => {
    reduxDispatch(GtmHeaderNavClick(url));
  };

  const blackFridayIsActive = useSelector(selectBlackFridayStatus);

  return (
    <>
      <div
        className={cn(styles.section, styles.brand, {
          [styles.outside]: outside,
          [styles.blackFriday]: blackFridayIsActive
        })}
      >
        <NotifyLink onClick={handleOnClick} className={styles.brandLink} ticket={ticket} url={url}>
          <div className={styles.icon}>
            <IconBrands />
          </div>
          <span>{last}</span>
        </NotifyLink>
      </div>
    </>
  );
});
